export default "__VITE_ASSET__BTwVgJXN__"